$ = require('jquery')

require('matchHeight')

module.exports =
	init: (payload) ->
		{$target} = payload

		option =
			byRow: true
			property: 'min-height'
			target: null
			remove: false

		$target.find('.box-grid__inner').matchHeight(option)

		$target.find('.box-product__content').matchHeight(option)
		$target.find('.box-article-grid__content').matchHeight(option)

		$target.find('.box-event').not('.box-event--side').find('.box-event__content').matchHeight(option)

		$target.find('.crossroad-std').each(->
			$(this).find('.box-category, .box-article-grid:not(.grid__cell .grid__cell>.box-article-grid)').matchHeight()
		)

		$target.find('.grid__cell .grid__cell>.box-article-grid').matchHeight()

		# homepage nested grid custom match height
		$.fn.matchHeight._beforeUpdate = (event, groups)->
			$gridTopLevel = $target.find('.js-equal-nested-grid>.grid')
			$gridTopLevel.find('.box-article-grid').height('auto')

		$.fn.matchHeight._afterUpdate = (event, groups)->
			if ($(window).width() < 700)
				return

			$gridTopLevel = $target.find('.js-equal-nested-grid>.grid')
			$gridNextLevel = if $gridTopLevel.length then $gridTopLevel.find('.grid') else null

			if $gridNextLevel and $gridNextLevel.length
				$gridCell = $gridNextLevel.closest('.grid__cell')
				$articleCell = $gridCell.siblings()
				$gridTopLevel.find('.box-article-grid')

				if $articleCell.height() < $gridCell.height()
					$articleCell.find('.box-article-grid').height($gridCell.height())
				else if $articleCell.height() > $gridCell.height()
					delta = $articleCell.height() - $gridCell.height()
					$articles = $gridCell.find('.box-article-grid')
					rowsCount = Math.ceil($articles.length / Math.floor($gridCell.width() / $articles.width()))
					modulo = delta % rowsCount

					addHeight = Math.floor(delta / rowsCount)
					$articles.each((i)->
						if modulo > 0 and i < modulo
							$(@).outerHeight($(@).outerHeight() + addHeight + 1)
						else
							$(@).outerHeight($(@).outerHeight() + addHeight)
					)

			$target.find('.crossroad-std').each(->
				$(this).find('.box-article-grid:not(.grid__cell .grid__cell>.box-article-grid)').each(->
					$box = $(@)
					$content = $box.find('.box-article-grid__content')

					if $box.is('.box-article-grid--noimg')
						$content.height('auto')

					if $box.is('.box-article-grid') and $box.is('.box-article-grid--noimg') and not $box.is('.box-article-grid--noborder') and $content.outerHeight() < $box.height()
						$content.outerHeight($box.height())
				)
			)



/** WEBPACK FOOTER **
 ** ./src/js/components/matchHeight.coffee
 **/